import SocketService from "../common/CompositionAPI/socket";

const host = process.env.VUE_APP_SESSION_API.split("api/v1")[0];
const payloadSocket = { host, path: "/api/v1/socket" };

const SocketSessions = new SocketService(payloadSocket);

export default SocketSessions;
